import type { Me } from '@/features/auth/sessao';

export type Papel = NonNullable<Me['papel']>;

const GESTAO = ['owner', 'admin'] as const;
const EQUIPE = ['owner', 'admin', 'profissional'] as const;

/**
 * Matriz `recurso:ação → papéis` do backend (`src/auth/permissoes.ts`; docs/07-api.md). O painel
 * só a usa para esconder botões e menus: quem autoriza é sempre a API (constituição III.3).
 * O teste `__tests__/matriz.test.ts` confere cada linha com a tabela da documentação.
 */
export const MATRIZ = {
  'organization:update': GESTAO,
  'usuario:read': EQUIPE,
  'usuario:create': GESTAO,
  'usuario:update': GESTAO,
  'usuario:delete': GESTAO,
  'perfil:update': EQUIPE,
  'cadastro:read': EQUIPE,
  'cadastro:create': GESTAO,
  'cadastro:update': GESTAO,
  'cadastro:delete': GESTAO,
  'exercicio:read': EQUIPE,
  'exercicio:create': EQUIPE,
  'exercicio:update': EQUIPE,
  'exercicio:delete': EQUIPE,
  'ficha:read': EQUIPE,
  'ficha:create': EQUIPE,
  'ficha:update': EQUIPE,
  'ficha:delete': EQUIPE,
  'plano:read': EQUIPE,
  'plano:create': EQUIPE,
  'plano:update': EQUIPE,
  'plano:delete': EQUIPE,
  'plano:purge': GESTAO,
  'atendimento:read': EQUIPE,
  'atendimento:create': EQUIPE,
  'atendimento:update': EQUIPE,
  'atendimento:delete': EQUIPE,
  'documento:read': EQUIPE,
  'documento:create': EQUIPE,
  'documento:update': EQUIPE,
  'documento:delete': EQUIPE,
  'curso:read': EQUIPE,
  'curso:create': GESTAO,
  'curso:update': GESTAO,
  'curso:delete': GESTAO,
  'registroTreino:read': EQUIPE,
  'registroTreino:create': ['aluno'],
  'registroTreino:delete': GESTAO,
  'pagamento:read': GESTAO,
  'pagamento:manage': GESTAO,
  'auditoria:read': GESTAO,
} as const satisfies Record<string, readonly Papel[]>;

export type Permissao = keyof typeof MATRIZ;

/** O papel na empresa ativa permite a ação? Sem papel (sem empresa ativa), nada. */
export function pode(papel: Papel | null | undefined, permissao: Permissao): boolean {
  if (papel == null) return false;
  return (MATRIZ[permissao] as readonly Papel[]).includes(papel);
}
